import { Injectable } from '@angular/core';
import { Map } from 'immutable';

import { SubscriptionItemEntity } from './subscription-item.entity';
import {
	ISubscriptionListExtra,
	SubscriptionListEntity,
} from './subscription-list.entity';

@Injectable()
export class SubscriptionListProvider {
	private subscriptionList: SubscriptionListEntity =
		SubscriptionListEntity.build([]);

	public constructor() {}

	public getAvailableColumns(
		withDatablock: boolean
	): Array<ISubscriptionListExtra> {
		const availableCols: Array<ISubscriptionListExtra> = [
			{
				field: 'label',
				alias: $localize`:i18n=@@subscription.list.column.label:`,
				type: 'string',
				isFilterable: true,
				isSearchable: true,
				hasHeaderFilter: false,
				canBeReordered: true,
				visibleIndex: 0,
			},
			{
				field: 'tags',
				alias: $localize`:i18n=@@subscription.list.column.tags:`,
				type: '',
				isFilterable: true,
				isSearchable: true,
				hasHeaderFilter: false,
				canBeReordered: false,
				visibleIndex: 1,
			},
			{
				field: 'status',
				alias: $localize`:i18n=@@subscription.list.column.status:`,
				type: '',
				isFilterable: false,
				isSearchable: true,
				hasHeaderFilter: true,
				canBeReordered: true,
				visibleIndex: 2,
			},
			{
				field: 'dataCount',
				alias: $localize`:i18n=@@subscription.list.column.lines:`,
				type: 'integer',
				isFilterable: false,
				isSearchable: false,
				hasHeaderFilter: false,
				canBeReordered: false,
				visibleIndex: 3,
			},
			{
				field: 'updatedBy',
				alias: $localize`:i18n=@@subscription.list.column.updatedBy:`,
				type: 'string',
				isFilterable: true,
				isSearchable: true,
				hasHeaderFilter: false,
				canBeReordered: true,
				visibleIndex: 4,
			},
		];

		if (!withDatablock) {
			availableCols.push({
				field: 'datablockSource',
				alias: $localize`:i18n=@@subscription.list.column.source:`,
				type: '',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: true,
				canBeReordered: true,
				visibleIndex: 5,
			});
		}

		return availableCols;
	}

	public setList(cols: Array<ISubscriptionListExtra>): void {
		this.subscriptionList = SubscriptionListEntity.build(cols);
	}

	public setListElements(
		elements: Map<string, SubscriptionItemEntity>,
		total: number
	): SubscriptionListEntity {
		return this.subscriptionList.setElements(elements).setTotalItems(total);
	}
}
